import AbstractException from '../AbstractException.js';
import ExceptionTypeEnum from '../enums/ExceptionTypeEnum.js';
/**
 * Custom exception.
 */
export default class ServiceException extends AbstractException {
    constructor() {
        super(...arguments);
        this.exceptionType = ExceptionTypeEnum.service;
        this.name = 'ServiceException';
    }
}
//# sourceMappingURL=ServiceException.js.map